import { render, staticRenderFns } from "./Tabla_Registro.vue?vue&type=template&id=c60872f8&scoped=true&"
import script from "./Tabla_Registro.vue?vue&type=script&lang=js&"
export * from "./Tabla_Registro.vue?vue&type=script&lang=js&"
import style0 from "./Tabla_Registro.vue?vue&type=style&index=0&id=c60872f8&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c60872f8",
  null
  
)

export default component.exports